<template>
    <el-dropdown @command="handleChangeLan">
        <el-button type="primary">
            {{ language }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in languages" :key="item.id" :command="index">{{ item.title
            }}</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
export default {
    data() {
        return {
            language: "中文(简体)",
            languages: [{
                id: "1",
                title: "中文(简体)",
                language: "zh-cn"
            },{
                id: "2",
                title: "中文(繁体)",
                language: "zh-TW"
            },            
            {
                id: "3",
                title: "English(US)",
                language: "en-us"
            }
            ,            
            {
                id: "5",
                title: "Español(ES)",
                language: "es-es"
            }
        ]
        }
    },
    methods: {
        handleChangeLan(index) {
            this.language = this.languages[index].title
            //保存语言环境
            this.$i18n.locale = this.languages[index].language
            this.$store.dispatch('app/updateLanguages', this.languages[index].language)
            this.moment.locale(this.languages[index].language);
            // console.log(this.moment().format('LL'));

        }
    },
    mounted() {

        var locale = this.$store.getters.locale;
        this.languages.forEach(element => {
            if (element.language == locale) {
                this.language = element.title;
            }
        });
    }
}
</script>